"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenProductInfoDialogDialog = exports.Name = exports.DialogMode = void 0;
const Name = exports.Name = 'open-product-info-dialog';
const OpenProductInfoDialogDialog = exports.OpenProductInfoDialogDialog = Name;
let DialogMode = exports.DialogMode = /*#__PURE__*/function (DialogMode) {
  DialogMode["Loading"] = "loading";
  DialogMode["StandardBuy"] = "standardBuy";
  return DialogMode;
}({});
//# sourceMappingURL=event.js.map